import { render } from "./VersionsDisplay.vue?vue&type=template&id=c96f1616"
import script from "./VersionsDisplay.vue?vue&type=script&lang=js"
export * from "./VersionsDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__